module.exports = __webpack_public_path__ + "static/media/nebraska.e856a2cb.jpeg";